import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import OnScreen from 'components/OnScreen';
import Button from 'components/Button';
import EventCard from 'components/EventCard';
import Icon from 'components/Icon';
import scrollToElement from "scroll-to-element";
import './TimelineBlock.scss';

class TimelineBlock extends React.Component {
    static propTypes = {
        projectStatusLabel: PropTypes.string,
        nextLabel: PropTypes.string,
        prevLabel: PropTypes.string,
        closeLabel: PropTypes.string,
        shortMonthNames: PropTypes.array.isRequired,
        fullMonthNames: PropTypes.array.isRequired,
        milestoneList: PropTypes.array.isRequired,
        projectStart: PropTypes.string,
        projectEnd: PropTypes.string,
        showTimelineLabel: PropTypes.string.isRequired,
        hideTimelineLabel: PropTypes.string.isRequired,
        onScreen: PropTypes.bool
    }

    state = {
        active: -1,
        on: false,
    }

    _getDateStamp = oldDate => {
        // 26-02-2012";
        if (!oldDate) return;
        var theDate = oldDate.split(".");
        //var newDate = theDate[1] + "." + theDate[0] + "." + theDate[2];
        //var newDate = theDate[0] + "/" + theDate[1] + "/" + theDate[2];

        // return (new Date(newDate).getTime());
        return (new Date(theDate[2], theDate[1] - 1, theDate[0]).getTime());
    }

    _futureFilter = event => {
        if (this._getDateStamp(event.date) >= Date.now()) {
            return event;
        }
    }

    // _pastFilter = e => {
    _pastFilter = event => {
        return Date.parse(event.dateAndTime) < Date.now();
    }

    _handleNavigationClick = e => {
        e.preventDefault();
        const { direction } = e.currentTarget.dataset;
        if (direction === "next") {
            if (this.props.milestoneList.length <= this.state.active + 1) return;
            this.setState({ active: this.state.active + 1 });
        }
        else if (direction === "prev") {
            if ((this.state.active - 1) < 0) return;
            this.setState({ active: this.state.active - 1 });
        }
    }

    _handleIndicatorClick = e => {
        e.preventDefault();
        const { id } = e.currentTarget.dataset;

        const active = id-1

        if(this.state.active == active) {
            return this.setState({
                active: -1,
                on: false
            });
        }

        this.setState({
            active,
            on: true,
        });

        var intViewportHeight = window.innerHeight;
        var scrollOffset =  intViewportHeight > 760 ? -intViewportHeight + 120 : -575;
        scrollToElement(e.currentTarget, {
            offset: scrollOffset,
            ease: "linear",
            duration: 500
        });
    }

    _getPastPercent = () => {
        const betweenStartAndEnd = (this._getDateStamp(this.props.projectEnd)) - (this._getDateStamp(this.props.projectStart));
        const betweenStartAndToday = Date.now() - (this._getDateStamp(this.props.projectStart));
        var percentBefore = (betweenStartAndToday / betweenStartAndEnd) * 100;
        if (percentBefore < 0) { percentBefore = 0; }
        if (percentBefore > 100) { percentBefore = 100; }
        return percentBefore;
    }

    _getPastDatePercent = event => {        
        const timeline =
        this._getDateStamp(this.props.projectEnd) -
        this._getDateStamp(this.props.projectStart);
        const startToEvent = (this._getDateStamp(event.date)) - (this._getDateStamp(this.props.projectStart));
        var percent = startToEvent / timeline * 100;
        if (percent < 0) { percent = 0; }
        if (percent > 100) { percent = 100; }
        return percent;
    }

    _getFutureDatePercent = event => {
        const timeline = (this._getDateStamp(this.props.projectEnd)) - Date.now();
        const endToEvent = (this._getDateStamp(this.props.projectEnd)) - (this._getDateStamp(event.date));
        var percent = endToEvent / timeline * 100;
        if (percent < 0) { percent = 0; }
        if (percent > 100) { percent = 100; }

        return percent;
    }

    _getMonth = thedate => {
        var monthNames = this.props.shortMonthNames; //["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"];
        var theDate = thedate.split(".");
        var newDate = monthNames[parseInt(theDate[1]) - 1] + " " + theDate[2];
        return newDate;
    }

    _close = () => {
        this.setState({
            on: false
        });
    }

    _toggleOn = () => {
        if (this.state.on == true) {
            this.setState({
                on: false
            });
        }
        if (this.state.on == false) {
            if (this.state.active === -1) {
                this.setState({
                    on: true,
                    active: 0
                });
            } else {
                this.setState({
                    on: true
                });
            }
        }
    }

    render() {
        const {
            hideTimelineLabel,
            showTimelineLabel,
            onScreen
        } = this.props;
        
        const projectStatusLabel =  this.props.projectStatusLabel;
        const nextLabel =  this.props.nextLabel;
        const prevLabel =  this.props.prevLabel;
        const closeLabel =  this.props.closeLabel;
        const events = this.props.milestoneList;
        const active = this.state.active;
        const startDate = this.props.projectStart;
        const endDate = this.props.projectEnd;
        const shortMonthNames = this.props.shortMonthNames;
        const fullMonthNames = this.props.fullMonthNames;

        return (           
            <div className={cn("timeline-block", {
                "active": this.state.on,
                'is-visible': onScreen,
            })}>
                <div className="timeline-block-content">
                    <h2 className="title">{projectStatusLabel}</h2>
                    <div className="modal" id="timeline-modal">
                        <div className="cards-frame">
                            <ul className="cards" style={{ transform: 'translateX(-' + (active * 100) + '%)' }}>
                                {events.map((event, index) => (
                                    <li key={index}>
                                        <EventCard event={event} close={this._close} closeLabel={closeLabel} monthNames={fullMonthNames} link={event.link} />
                                    </li>
                                ))}
                            </ul>
                            <div className="nav">
                                {(active > 0) && (
                                    <button
                                        type="button"
                                        className="prev"
                                        data-direction="prev"
                                        onClick={this._handleNavigationClick}
                                    >
                                        <Icon icon="arrow-left" />
                                        <span>{prevLabel}</span>
                                    </button>
                                )}

                                {!(active == (events.length - 1)) && (
                                    <button
                                        type="button"
                                        className="next"
                                        data-direction="next"
                                        onClick={this._handleNavigationClick}
                                    >
                                        <Icon icon="arrow-right" />
                                        <span>{nextLabel}</span>
                                    </button>
                                )}
                                <button
                                    className="close"
                                    onClick={this._close}
                                >
                                    <Icon icon="close" />
                                    <span>{closeLabel}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="timeline">
                        <ul className="past" style={{ width: this._getPastPercent() + '%' }}>
                            {this.props.milestoneList.filter(this._pastFilter).map(event => (
                                <li
                                    key={event.id + 1}
                                    style={{ left: (this._getPastDatePercent(event)) + '%' }}
                                >
                                    <button
                                        data-id={event.id + 1}
                                        onClick={this._handleIndicatorClick}
                                        className={active === this.props.milestoneList.indexOf(event) && this.state.on ? "active" : null}
                                    >
                                        <span>{event.title}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                        <div className="present">
                            <ul className="dot">
                                <li></li>
                                <li></li>
                                <li></li>
                            </ul>
                        </div>
                        <ul className="future" style={{ width: (100 - this._getPastPercent()) + '%' }}>
                            {this.props.milestoneList.filter(this._futureFilter).map(event => (
                                <li
                                    key={event.id + 1}
                                    style={{ right: (this._getFutureDatePercent(event)) + '%' }}
                                >
                                    <button
                                        data-id={event.id + 1}
                                        onClick={this._handleIndicatorClick}
                                        className={active === this.props.milestoneList.indexOf(event) && this.state.on ? "active" : null}
                                    >
                                        <span>{event.title}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="timeline-dates">
                        <div className="start">{this._getMonth(startDate)}</div>
                        <div className="end">{this._getMonth(endDate)}</div>
                    </div>
                    {this.props.milestoneList && this.props.milestoneList.length > 0 && (
                        <Button
                            className={cn("timeline-toggle-btn", {
                                ["active"]: this.state.on
                            })}
                            onClick={this._toggleOn}
                            light
                            secondary
                            type="button"
                        >
                            {this.state.on ? hideTimelineLabel : showTimelineLabel}
                        </Button>
                    )}
                </div>
            </div>
        );
    }
}

export default OnScreen(TimelineBlock);



// WEBPACK FOOTER //
// ./src/components/TimelineBlock/TimelineBlock.jsx